import { isAxiosError } from "axios"

const asText = async (body: unknown): Promise<string | null> => {
  if (typeof body === `string`) return body
  if (body instanceof Blob) return body.text()
  if (body instanceof ArrayBuffer || ArrayBuffer.isView(body)) {
    return new TextDecoder().decode(body)
  }

  return null
}

/**
 * A binary request hands back the gateway's JSON refusal as bytes too. Reading
 * it into place lets callers inspect `response.data.error` the way they do for
 * every other request, so an export shares the publish refusal copy.
 */
export const withReadableErrorBody = async (
  error: unknown,
): Promise<unknown> => {
  if (!isAxiosError(error) || error.response == null) {
    return error
  }

  try {
    const text = await asText(error.response.data)
    if (text != null) {
      error.response.data = JSON.parse(text)
    }
  } catch {
    // A non-JSON body is left alone; the status still tells the caller enough.
  }

  return error
}
